import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { VH_TOKEN } from '../types/tokenData.js';
export const vhTokensDescriptor = {
    name: VH_TOKEN,
    label: 'VH Token',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_tokens',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'API token for /api/v1. Minted and hashed by the VH server; console reads only.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'tokenId',
            label: 'Token ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: '== doc id.',
        },
        {
            name: 'name',
            label: 'Name',
            type: 'string',
            required: true,
            maxLength: 120,
        },
        {
            name: 'tokenHash',
            label: 'Token Hash',
            type: 'string',
            required: true,
            maxLength: 256,
            description: 'bcrypt hash of the plaintext secret — never sent to the client.',
        },
        {
            name: 'prefix',
            label: 'Prefix',
            type: 'string',
            required: true,
            maxLength: 16,
            description: 'Short prefix shown for identification (e.g. "vh_abc").',
        },
        {
            name: 'allowedModules',
            label: 'Allowed Modules',
            type: 'array',
            required: true,
            arrayItemType: 'string',
            description: 'Module slugs this token may access. Each slug max 80 chars.',
        },
        {
            name: 'allowedResources',
            label: 'Allowed Resources',
            type: 'array',
            required: true,
            arrayItemType: 'string',
            description: 'Resource IDs this token may access. Each ID max 128 chars.',
        },
        {
            name: 'expiresAt',
            label: 'Expires At',
            type: 'string',
            required: false,
            maxLength: 32,
            description: 'ISO 8601 expiry timestamp, or null for no expiry.',
        },
        {
            name: 'enabled',
            label: 'Enabled',
            type: 'boolean',
            required: true,
        },
        {
            name: 'createdAt',
            label: 'Created At',
            type: 'string',
            required: true,
            maxLength: 32,
        },
        {
            name: 'createdBy',
            label: 'Created By',
            type: 'string',
            required: true,
            maxLength: 128,
        },
        {
            name: 'lastUsedAt',
            label: 'Last Used At',
            type: 'string',
            required: false,
            maxLength: 32,
            description: 'ISO 8601 timestamp, or null if never used.',
        },
    ],
};
//# sourceMappingURL=vhTokens.descriptor.js.map